<template>
  <div class="color-bar-wrapper">
    <div class="type-title">{{typeName}}：</div>
    <div v-show="barMode == 'ord'" class="color_bars" @mouseover="showAll=true" @mouseout="showAll=false">
      <div  v-show="showAll">
        <div v-show="color_bar!==1" @click="changeMapColor('intensity',range_color1, 1)" class="color_bar" :style="{background:gra_color}"></div>
        <div v-show="color_bar!==2" @click="changeMapColor('intensity',range_color2, 2)" class="color_bar" :style="{background:gra_color2}"></div>
        <div v-show="color_bar!==3" class="color_bar" @click="changeMapColor('choropleth',split_color, 3)">
          <div style="position: absolute;"></div>
          <div v-for="c in split_color[dataType]" :style="{background: c.value}" class="color_block"></div>
        </div>
      </div>
      <div >
        
        
        <div v-show="color_bar==1" @click="changeMapColor('intensity',range_color1, 1)" class="color_bar" :style="{background:gra_color}"> 
          <span class="color_start">{{min}}</span> <span class="color_end">{{max}}</span>
        </div>
        <div v-show="color_bar==2" @click="changeMapColor('intensity',range_color2, 2)" class="color_bar" :style="{background:gra_color2}">
          <span class="color_start">{{min}}</span> <span class="color_end">{{max}}</span>
        </div>
        <div v-show="color_bar==3" class="color_bar" @click="changeMapColor('choropleth',split_color, 3)">
          <div v-for="(c,idx) in split_color[dataType]" :style="{background: c.value}" class="color_block">
            <div class="color_start" style="position: absolute;text-align: center;" v-show="idx == 0">0</div>
            <div class="color_end" style="position: absolute;float: right;width: 16.6%;text-align: right;" v-show="idx == split_color[dataType].length-1">{{color_max[dataType]}}</div>
          </div>
        </div>
      </div>
  </div>

  <div v-show="barMode == 'pm10_pm25'" class="color_bars" >
    <div class="color_bar" @click="changeMapColor('choropleth',split_color_pm10_pm25, 3)">
      <div v-for="(c,idx) in split_color_pm10_pm25" :style="{background: c.value}" class="color_block" style="width: 33.33%">
        <div class="color_end" style="position: absolute;text-align: center;" >{{c.start}} {{c.label}}</div>
        <!-- <div class="color_end" style="position: absolute;float: right;width: 33.33%;text-align: right;" >{{c.label}}</div> -->
      </div>
    </div>
  </div>	
</div>
</template>

<script>
import {range_color1,range_color2,split_color,font_color,type_name,zoomCircleSize, color_max, split_color_pm10_pm25} from '@/utils/common.js'
import {tpOptions} from '@/options/option'
import {mapGetters} from 'vuex'
export default{
  data(){
    return{ 
      color_max,
    	split_color,
    	range_color1,
    	range_color2,
    	showAll:false,
    	color_bar:1,
      split_color_pm10_pm25,
    }
  },
  props:[
  	'dataType',
    'min',
    'max',
    "barMode"
  ],
  computed:{
    ...mapGetters(["tpOptionsGetter"]),
    typeName() {
      let f = this.tpOptionsGetter.find(x=>x.value === this.dataType)
      if (f) {return f.name}else {return this.dataType}
    },
  	gra_color(){
      let colors = this.$_.filter(this.range_color1[this.dataType], function(o) { return o.r > 0; });
      return `linear-gradient(to right,${this.$_.map(colors,function(x){return x.c}).join(',')})` 
    },
    gra_color2(){
      let colors = this.$_.filter(this.range_color2[this.dataType], function(o) { return o.r > 0; });
      return `linear-gradient(to right,${this.$_.map(colors,function(x){return x.c}).join(',')})` 
    },
  },
  mounted(){
    this.changeMapColor('intensity', this.range_color1, this.color_bar)
  },
  methods:{
  	changeMapColor(type, range, color_bar){
      this.color_bar = color_bar
  		this.$emit('changeMapColor', type ,range, this.color_bar)
  	}
  }
}
</script>

<style scoped>
.type-title {
  color: black;
  /* position: absolute;
  bottom: 0;
  right: 410px; */
  /* background-color: white; */
  display: inline-block;
}
.color-bar-wrapper {
  background-color: white;
  padding: 2px;
  position: absolute;
  padding: 5px;
  border-radius: 4px;
  right: 0;
  bottom: 0px;
  display: flex;
}
</style>


// WEBPACK FOOTER //
// src/components/ColorBar.vue